import React from 'react'
import { useLocaleStore } from '../../Contexts/LocaleContext'
import { useViewStore } from '../../Contexts/ViewContext'
import { useUtilsStore } from '../../Contexts/UtilsContext'
import { CurrentSubView } from '../../../models/enums'
import ParameterButton from './ParameterButton'

interface HistoryButtonProps {
  handleBack?: () => void
}

const HistoryButton = ({ handleBack }: HistoryButtonProps): JSX.Element => {
  const translation = useLocaleStore((state) => state.currentTranslations)
  const themeColors = useViewStore((state) => state.themeColors)
  const currentSubView = useUtilsStore((state) => state.currentSubView)
  const setCurrentSubView = useUtilsStore(
    (state) => state.actions.setCurrentSubView
  )

  const handleClick = (): void => {
    handleBack?.()
    setCurrentSubView(
      currentSubView === CurrentSubView.history
        ? CurrentSubView.none
        : CurrentSubView.history
    )
  }

  return (
    <ParameterButton
      title={translation.history.title}
      icon='history'
      color={
        currentSubView === CurrentSubView.history
          ? themeColors.secondary
          : '#A4A7AF'
      }
      onClick={handleClick}
    />
  )
}

export default HistoryButton
